<template>
  <CHeader fixed with-subheader light>
    <CHeaderNav class="mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          <img
            class="c-sidebar-brand-full"
            size="custom-size"
            :height="35"
            src="../../assets/fabbi_logo.jpeg"
          />
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <select
        v-model="$i18n.locale"
        class="form-control"
        @change="changeLanguage($event)"
      >
        <option
          v-for="(lang, i) in $store.getters['lang/locales']"
          :key="`Lang${i}`"
          :value="lang"
        >
          {{ $t(`locale.${lang}`) }}
        </option>
      </select>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "HeaderGuest",
  data() {
    return {
      locales: [
        {
          text: "ja"
        },
        {
          text: "en"
        },
        {
          text: "vi"
        }
      ],
      fullPath: "",
      keyword: "",
      localeSelect: null
    };
  },
  computed: {
    ...mapState("lang", {
      locale: state => {
        return state.locale;
      }
    })
  },
  created() {
    let localeSelect = this.locales.filter(item => item.text === this.locale);
    this.localeSelect = localeSelect.length > 0 ? localeSelect[0] : "ja";
  },
  methods: {
    ...mapActions("lang", ["setLocale"]),
    changeLanguage(event) {
      let locale = event.target.value;
      this.setLocale({ locale });
    }
  }
};
</script>

<style lang="scss">
.c-header-brand {
  text-decoration: none !important;
}

.logo-text {
  font-size: 20px;
}

.box-language {
  padding: 0 10px;
  margin-bottom: 0;
}
</style>
